import { render } from "./PhoneInject.vue?vue&type=template&id=3cd3d240"
import script from "./PhoneInject.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneInject.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/injectComponents/PhoneInject.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cd3d240"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cd3d240', __exports__)) {
    api.reload('3cd3d240', __exports__)
  }
  
  module.hot.accept("./PhoneInject.vue?vue&type=template&id=3cd3d240", () => {
    api.rerender('3cd3d240', render)
  })

}


export default __exports__